// Core
import React from "react"
import styled from "styled-components"

// General components
import Title from "../../../../../../components/Title"
import Paragraph from "../../../../../../components/Paragraph"
import CTALink from "../../../../../../components/CTALink"

// Style
import size from "../../../../../../styles/size"

const Container = styled.div`
  width: 100%;
  margin-left: 12rem;
  margin-top: 2.3rem;

  p {
    margin-top: 3rem;
    width: 100%;
    max-width: 525px;
  }

  @media (max-width: ${size.laptop}) {
    margin-top: 2rem;
    margin-left: 0;
  }
`

export default function CopyContainer() {
  return (
    <Container>
      <Title darkBG>Contribuições e Doações</Title>

      <Paragraph darkBG>
        A generosidade é uma resposta ao amor de Deus por nós com nossos
        dízimos, ofertas e doações específicas.
      </Paragraph>

      <CTALink
        pictonBlueBG
        lightText
        rel="noopener"
        href="https://www.oceanodagraca.com/pagamento/"
        target="_blank"
      >
        CONTRIBUA ONLINE
      </CTALink>
    </Container>
  )
}
